import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollInFlowActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail',
  options
}) => {
  const {
    flowId
  } = actionMetadata;
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.enroll-in-flow.action-detail.content",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: PLATFORM,
        id: flowId
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.enroll-in-flow.action-preview.content",
    options: Object.assign({}, options, {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: PLATFORM,
        id: flowId
      })
    })
  });
};
export default EnrollInFlowActionDetail;